

export const GET_NOTIFICATION_COUNT = 'GET_NOTIFICATION_COUNT';
export const GET_NOTIFICATION_COUNT_SUCCESS = 'GET_NOTIFICATION_COUNT_SUCCESS';

export const COMMON_STATE = "COMMON_STATE"